module.exports = __webpack_public_path__ + "static/media/vuln-info-banner.fe467f5b.png";